import { BasicModalLoaderPayload } from './basic-modal-loader-payload';

/**
 * Created by 310293471 on 19/03/2018.
 */
export class ConfirmModalLoaderPayload extends BasicModalLoaderPayload {
  public approveBtn?: string;
  public declineBtn?: string;

  constructor(title: string, content?: string, approveBtnText?: string, declineBtnText?: string) {
    super(title, content);
    this.approveBtn = approveBtnText;
    this.declineBtn = declineBtnText;
  }

  static builder() {
    return new this(null);
  }

  setApproveButtonText(text: string) {
    this.approveBtn = text;
    return this;
  }

  setDeclineButtonText(text: string) {
    this.declineBtn = text;
    return this;
  }
}
